import * as React from 'react';
import * as Sentry from '@sentry/react';
import { Route, Navigate, Routes, Location } from 'react-router-dom';
import wrapPage from './components/templates/page-wrap/hoc';
import LegalAdviseDisclaimer from './components/pages/landing';
import InfoProcessing from './components/pages/infoProcessing';
import PersonalInfoSectionStart from './components/pages/personal-info/sectionStart';
import PersonalInfoSectionIntro from './components/pages/personal-info/intro';
import PersonalInfoQPage1 from './components/pages/personal-info/qPage1';
import PersonalInfoQPage2 from './components/pages/personal-info/qPage2';
import PersonalInfoQPage3 from './components/pages/personal-info/qPage3';
import PersonalInfoQPage4 from './components/pages/personal-info/qPage4';
import PersonalInfoQPage5 from './components/pages/personal-info/qPage5';
import PersonalInfoQPage5_1 from './components/pages/personal-info/qPage5_1';
import PersonalInfoQPage6 from './components/pages/personal-info/qPage6';
import PersonalInfoQPage7 from './components/pages/personal-info/qPage7';
import PersonalInfoQPage8 from './components/pages/personal-info/qPage8';
import PersonalInfoQPage9 from './components/pages/personal-info/qPage9';
import PersonalInfoQPage10 from './components/pages/personal-info/qPage10';
import HistoryQpage1 from './components/pages/history/qPage1';
import HistoryQpage2 from './components/pages/history/qPage2';
import HistoryQpage3 from './components/pages/history/qPage3';
import ConsentsQpage1 from './components/pages/consents/qpage1';
import ConsentsQpage2 from './components/pages/consents/qpage2';
import ConsentsQpage3 from './components/pages/consents/qpage3';
import ConsentsQpage4 from './components/pages/consents/qpage4';
import FinanceQpage1 from './components/pages/finance/qPage1';
import PreCasInterviewSectionStart from './components/pages/interview/sectionStart';
import PreCasInterviewQPage1 from './components/pages/interview/qPage1';
import PreCasInterviewQPage2 from './components/pages/interview/qPage2';
import PreCasInterviewQPage3 from './components/pages/interview/qPage3';
import PreCasInterviewQPage4 from './components/pages/interview/qPage4';
import PreCasInterviewSectionComplete from './components/pages/interview/sectionComplete';
import VisaPrepFormAddPIPage1 from './components/pages/visa/additional-personal-info/qPage1';
import VisaPrepFormAddPIPage2 from './components/pages/visa/additional-personal-info/qPage2';
import VisaPrepFormAddHistoryPage1 from './components/pages/visa/additional-history/qPage1';
import VisaPrepFormAddHistoryPage2 from './components/pages/visa/additional-history/qPage2';
import VisaPrepFormAddHistoryPage3 from './components/pages/visa/additional-history/qPage3';
import VisaPrepFormAddHistoryPage4 from './components/pages/visa/additional-history/qPage4';
import VisaPrepFormAddHistoryPage5 from './components/pages/visa/additional-history/qPage5';
import VisaPrepFormAddHistoryPage6 from './components/pages/visa/additional-history/qPage6';
import VisaPrepFormAddHistoryPage7 from './components/pages/visa/additional-history/qPage7';
import VisaPrepFormAddHistoryPage8 from './components/pages/visa/additional-history/qPage8';
import VisaPrepFormFamilyPage1 from './components/pages/visa/family/qPage1';
import VisaPrepFormFamilyPage2 from './components/pages/visa/family/qPage2';
import VisaPrepFormFamilyPage3 from './components/pages/visa/family/qPage3';
import VisaPrepFormFamilyPage4 from './components/pages/visa/family/qPage4';
import VisaPrepFormFamilyPage5 from './components/pages/visa/family/qPage5';
import VisaPrepFormOtherTravellersPage1 from './components/pages/visa/other-travellers/qPage1';
import VisaPrepFormArrivalPage1 from './components/pages/visa/arrival/qPage1';
import VisaPrepFormDeclarationsPage1 from './components/pages/visa/declarations/qPage1';
import VisaPrepFormUniEnrolmentPage1 from './components/pages/visa/uni-enrolment/qPage1';
import VisaPrepFormUniEnrolmentPage2 from './components/pages/visa/uni-enrolment/qPage2';
import VisaPrepFormUniEnrolmentPage3 from './components/pages/visa/uni-enrolment/qPage3';
import VisaPrepFormFeedbackPage1 from './components/pages/visa/feedback/qPage1';
import CourseConflictInfo from './components/pages/courseConflict';
import { StudentState } from './store/student/types';
import HistorySectionStart from './components/pages/history/sectionStart';
import ConsentsSectionStart from './components/pages/consents/sectionStart';
import FinancesSectionStart from './components/pages/finance/sectionStart';
import CompleteChecklist from './components/pages/completeChecklist';
import Dashboard from './components/pages/dashboard';
import StatusUpdate from './components/pages/statusUpdate';
import NoActiveIntake from './components/pages/noActiveIntake';
import IntakeSelector from './components/pages/intakeSelector';
import InactiveIntake from './components/pages/inactiveIntake';
import IntakeRoute from './components/organisms/IntakeRoute';
import {
  visaPrepFlags,
  canShowAgentQuestion,
  canShowVisaSupportQuestion,
  canShowWhatsappQuestion,
  canShowOfferEvidenceQuestion
} from './utilities/pages';
import * as types from 'types';
import { IStudentConfig } from './types';
import { OffersState } from './store/offers/types';
import { AuthState } from './store/auth/types';

const DashboardPage = wrapPage(Dashboard, true);

const LegalAdviseDisclaimerPage = wrapPage(LegalAdviseDisclaimer);
const InfoProcessingPage = wrapPage(InfoProcessing);
const PersonalInfoStart = wrapPage(PersonalInfoSectionStart);
const PersonalInfoIntro = wrapPage(PersonalInfoSectionIntro);
const PersonalInfoQ1P1 = wrapPage(PersonalInfoQPage1);
const PersonalInfoQ1P2 = wrapPage(PersonalInfoQPage2);
const PersonalInfoQ1P3 = wrapPage(PersonalInfoQPage3);
const PersonalInfoQ1P4 = wrapPage(PersonalInfoQPage4);
const PersonalInfoQ1P5 = wrapPage(PersonalInfoQPage5);
const PersonalInfoQ1P51 = wrapPage(PersonalInfoQPage5_1);
const PersonalInfoQ1P6 = wrapPage(PersonalInfoQPage6);
const PersonalInfoQ1P7 = wrapPage(PersonalInfoQPage7);
const PersonalInfoQ1P8 = wrapPage(PersonalInfoQPage8);
const PersonalInfoQ1P9 = wrapPage(PersonalInfoQPage9);
const PersonalInfoQ1P10 = wrapPage(PersonalInfoQPage10);

const HistorySectionStartPage = wrapPage(HistorySectionStart);
const HistoryQ1P1 = wrapPage(HistoryQpage1);
const HistoryQ1P2 = wrapPage(HistoryQpage2);
const HistoryQ1P3 = wrapPage(HistoryQpage3);

const ConsentsSectionStartPage = wrapPage(ConsentsSectionStart);
const ConsentsQ1P1 = wrapPage(ConsentsQpage1);
const ConsentsQ1P2 = wrapPage(ConsentsQpage2);
const ConsentsQ1P3 = wrapPage(ConsentsQpage3);
const ConsentsQ1P4 = wrapPage(ConsentsQpage4);

const FinancesSectionStartPage = wrapPage(FinancesSectionStart);

const CompleteChecklistPage = wrapPage(CompleteChecklist);

const FinanceQ1P1 = wrapPage(FinanceQpage1);

const PreCasInterviewSectionStartPage = wrapPage(PreCasInterviewSectionStart);
const PreCasInterviewQP1 = wrapPage(PreCasInterviewQPage1);
const PreCasInterviewQP2 = wrapPage(PreCasInterviewQPage2);
const PreCasInterviewQP3 = wrapPage(PreCasInterviewQPage3);
const PreCasInterviewQP4 = wrapPage(PreCasInterviewQPage4);
const PreCasInterviewSectionCompletePage = wrapPage(PreCasInterviewSectionComplete);

const VPFAddPIPage1 = wrapPage(VisaPrepFormAddPIPage1);
const VPFAddPIPage2 = wrapPage(VisaPrepFormAddPIPage2);
const VPFAddHistoryPage1 = wrapPage(VisaPrepFormAddHistoryPage1);
const VPFAddHistoryPage2 = wrapPage(VisaPrepFormAddHistoryPage2);
const VPFAddHistoryPage3 = wrapPage(VisaPrepFormAddHistoryPage3);
const VPFAddHistoryPage4 = wrapPage(VisaPrepFormAddHistoryPage4);
const VPFAddHistoryPage5 = wrapPage(VisaPrepFormAddHistoryPage5);
const VPFAddHistoryPage6 = wrapPage(VisaPrepFormAddHistoryPage6);
const VPFAddHistoryPage7 = wrapPage(VisaPrepFormAddHistoryPage7);
const VPFAddHistoryPage8 = wrapPage(VisaPrepFormAddHistoryPage8);
const VPFFamilyPage1 = wrapPage(VisaPrepFormFamilyPage1);
const VPFFamilyPage2 = wrapPage(VisaPrepFormFamilyPage2);
const VPFFamilyPage3 = wrapPage(VisaPrepFormFamilyPage3);
const VPFFamilyPage4 = wrapPage(VisaPrepFormFamilyPage4);
const VPFFamilyPage5 = wrapPage(VisaPrepFormFamilyPage5);
const VPFOtherTravellersPage1 = wrapPage(VisaPrepFormOtherTravellersPage1);
const VPFArrivalPage1 = wrapPage(VisaPrepFormArrivalPage1);
const VPFDeclarationsPage1 = wrapPage(VisaPrepFormDeclarationsPage1);
const VPFUniEnrolmentPage1 = wrapPage(VisaPrepFormUniEnrolmentPage1);
const VPFUniEnrolmentPage2 = wrapPage(VisaPrepFormUniEnrolmentPage2);
const VPFUniEnrolmentPage3 = wrapPage(VisaPrepFormUniEnrolmentPage3);
const VPFFeedbackPage1 = wrapPage(VisaPrepFormFeedbackPage1);

const CourseConflictPage = wrapPage(CourseConflictInfo);

const PERSONAL_INFO = 'personal-info';
const HISTORY = 'history';
const FINANCES = 'finances';
const CONSENTS = 'consents';
const PRE_CAS_INTERVIEW = 'interview';
export const VISA_PREP_FORM = 'visa-prep-form';

interface Props {
  student: StudentState;
  config: IStudentConfig;
  offers: OffersState;
  auth: AuthState;
  location?: Location;
}

export const CustomRoutes = (props: Props) => {
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
  const {
    nonHomeCountryApplication,
    hasTravelledToUk,
    hasLeaveToRemain,
    hasBorderRefusal,
    hasOtherTravellers,
    hasTakenEnglishTest
  } = visaPrepFlags(props.student.personalInfo, props.student.history, props.student.offer as types.IOffer);

  const isHistorySectionActive = props.config.historySectionStatus === types.SectionStatusType.ACTIVE;
  const isFinanceSectionActive = props.config.financeSectionStatus === types.SectionStatusType.ACTIVE;

  const showAgentQuestion = canShowAgentQuestion(props.student.importData, props.student.offer as types.IOffer);

  const showVisaSupportQuestion = canShowVisaSupportQuestion(
    props.student.personalInfo,
    props.student.importData,
    props.config,
    props.student.offer as types.IOffer
  );
  const showWhatsappQuestion = canShowWhatsappQuestion(props.student.offer as types.IOffer);
  const showOfferEvidenceQuestion = canShowOfferEvidenceQuestion(
    props.student.offer as types.IOffer,
    props.student.importData,
    props.student.conflictHistory,
    props.config
  );

  const isCourseConflict = props.student.offer.isCourseConflict;

  /* "Course Conflict" is a special state when student course data isn't valid
   * and student is blocked from the journey until this conflict is sorted out
   */
  if (isCourseConflict && props.config.enableStudentCourseBlock === true) {
    return (
      <SentryRoutes>
        <Route path={'/'} element={<CourseConflictPage />} />
        <Navigate to="/" />
      </SentryRoutes>
    );
  }

  return (
    <SentryRoutes>
      <Route path={'/inactive-intake'} element={<InactiveIntake />} />
      <Route path="/intake-select" element={<IntakeSelector />} />
      <Route path="/no-active-intake" element={<NoActiveIntake />} />
      <Route
        path={'/'}
        element={
          <IntakeRoute
            redirect={
              props.location?.state?.from
                ? props.location?.state?.from
                : props.offers.activeOffer?.intakeId && props.offers.activeOffer?.offerId
                ? `/${props.offers.activeOffer.intakeId}/${props.offers.activeOffer.offerId}/dashboard`
                : undefined
            }
          />
        }
      />
      <Route
        path={'/:intakeId/:offerId'}
        element={
          <IntakeRoute
            redirect={
              props.offers.activeOffer?.intakeId && props.offers.activeOffer?.offerId
                ? `/${props.offers.activeOffer.intakeId}/${props.offers.activeOffer.offerId}/dashboard`
                : undefined
            }
          />
        }
      />
      <Route path={'/:intakeId/:offerId/dashboard'} element={<IntakeRoute element={<DashboardPage />} />} />

      <Route path={'/:intakeId/:offerId/landing'} element={<IntakeRoute element={<LegalAdviseDisclaimerPage />} />} />
      <Route path={'/:intakeId/:offerId/infoProcessing'} element={<IntakeRoute element={<InfoProcessingPage />} />} />
      <Route
        path={`/:intakeId/:offerId/${PERSONAL_INFO}/section-start`}
        element={<IntakeRoute element={<PersonalInfoStart />} />}
      />
      {Object.keys(props.student.importData).length > 0 && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/introduction`}
          element={<IntakeRoute element={<PersonalInfoIntro />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page1.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-1`}
          element={<IntakeRoute element={<PersonalInfoQ1P1 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page2.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-2`}
          element={<IntakeRoute element={<PersonalInfoQ1P2 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page3.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-3`}
          element={<IntakeRoute element={<PersonalInfoQ1P3 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page4.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-4`}
          element={<IntakeRoute element={<PersonalInfoQ1P4 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page5.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-5`}
          element={<IntakeRoute element={<PersonalInfoQ1P5 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page5_1.hidden && showOfferEvidenceQuestion && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-5-1`}
          element={<IntakeRoute element={<PersonalInfoQ1P51 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page6.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-6`}
          element={<IntakeRoute element={<PersonalInfoQ1P6 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page7.hidden && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-7`}
          element={<IntakeRoute element={<PersonalInfoQ1P7 />} />}
        />
      )}
      {props.config.Checklist.PersonalInfo.Page8.hidden !== true && showAgentQuestion && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-8`}
          element={<IntakeRoute element={<PersonalInfoQ1P8 />} />}
        />
      )}
      {props.config.Checklist.PersonalInfo.Page9.hidden !== true && showVisaSupportQuestion && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-9`}
          element={<IntakeRoute element={<PersonalInfoQ1P9 />} />}
        />
      )}
      {!props.config.Checklist.PersonalInfo.Page10.hidden && showWhatsappQuestion && (
        <Route
          path={`/:intakeId/:offerId/${PERSONAL_INFO}/step-10`}
          element={<IntakeRoute element={<PersonalInfoQ1P10 />} />}
        />
      )}
      {isHistorySectionActive && (
        <Route
          path={`/:intakeId/:offerId/${HISTORY}/section-start`}
          element={<IntakeRoute element={<HistorySectionStartPage />} />}
        />
      )}
      {isHistorySectionActive && (
        <Route path={`/:intakeId/:offerId/${HISTORY}/step-1`} element={<IntakeRoute element={<HistoryQ1P1 />} />} />
      )}
      {isHistorySectionActive && (
        <Route path={`/:intakeId/:offerId/${HISTORY}/step-2`} element={<IntakeRoute element={<HistoryQ1P2 />} />} />
      )}
      {isHistorySectionActive && (
        <Route path={`/:intakeId/:offerId/${HISTORY}/step-3`} element={<IntakeRoute element={<HistoryQ1P3 />} />} />
      )}
      <Route
        path={`/:intakeId/:offerId/${CONSENTS}/section-start`}
        element={<IntakeRoute element={<ConsentsSectionStartPage />} />}
      />
      <Route path={`/:intakeId/:offerId/${CONSENTS}/step-1`} element={<IntakeRoute element={<ConsentsQ1P1 />} />} />
      {!props.config.Checklist.Consents.Page2.hidden && (
        <Route path={`/:intakeId/:offerId/${CONSENTS}/step-2`} element={<IntakeRoute element={<ConsentsQ1P2 />} />} />
      )}
      {!props.config.Checklist.Consents.Page3.hidden && props.student.offer.visaSupport && (
        <Route path={`/:intakeId/:offerId/${CONSENTS}/step-3`} element={<IntakeRoute element={<ConsentsQ1P3 />} />} />
      )}
      {!props.config.Checklist.Consents.Page4.hidden && (
        <Route path={`/:intakeId/:offerId/${CONSENTS}/step-4`} element={<IntakeRoute element={<ConsentsQ1P4 />} />} />
      )}
      {isFinanceSectionActive && (
        <Route
          path={`/:intakeId/:offerId/${FINANCES}/section-start`}
          element={<IntakeRoute element={<FinancesSectionStartPage />} />}
        />
      )}
      {isFinanceSectionActive && (
        <Route path={`/:intakeId/:offerId/${FINANCES}/step-1`} element={<IntakeRoute element={<FinanceQ1P1 />} />} />
      )}
      <Route path={`/:intakeId/:offerId/complete`} element={<IntakeRoute element={<CompleteChecklistPage />} />} />

      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/section-start`}
        element={<IntakeRoute element={<PreCasInterviewSectionStartPage />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/step-1`}
        element={<IntakeRoute element={<PreCasInterviewQP1 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/step-2`}
        element={<IntakeRoute element={<PreCasInterviewQP2 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/step-3`}
        element={<IntakeRoute element={<PreCasInterviewQP3 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/step-4`}
        element={<IntakeRoute element={<PreCasInterviewQP4 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${PRE_CAS_INTERVIEW}/section-complete`}
        element={<IntakeRoute element={<PreCasInterviewSectionCompletePage />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-personal-info/step-1`}
        element={<IntakeRoute element={<VPFAddPIPage1 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-personal-info/step-2`}
        element={<IntakeRoute element={<VPFAddPIPage2 />} />}
      />
      {nonHomeCountryApplication === true && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-1`}
          element={<IntakeRoute element={<VPFAddHistoryPage1 />} />}
        />
      )}
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-2`}
        element={<IntakeRoute element={<VPFAddHistoryPage2 />} />}
      />
      {hasTravelledToUk === true && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-3`}
          element={<IntakeRoute element={<VPFAddHistoryPage3 />} />}
        />
      )}
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-4`}
        element={<IntakeRoute element={<VPFAddHistoryPage4 />} />}
      />
      {hasLeaveToRemain === true && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-5`}
          element={<IntakeRoute element={<VPFAddHistoryPage5 />} />}
        />
      )}
      {hasBorderRefusal === true && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-6`}
          element={<IntakeRoute element={<VPFAddHistoryPage6 />} />}
        />
      )}
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-7`}
        element={<IntakeRoute element={<VPFAddHistoryPage7 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/additional-history/step-8`}
        element={<IntakeRoute element={<VPFAddHistoryPage8 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/family/step-1`}
        element={<IntakeRoute element={<VPFFamilyPage1 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/family/step-2`}
        element={<IntakeRoute element={<VPFFamilyPage2 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/family/step-3`}
        element={<IntakeRoute element={<VPFFamilyPage3 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/family/step-4`}
        element={<IntakeRoute element={<VPFFamilyPage4 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/family/step-5`}
        element={<IntakeRoute element={<VPFFamilyPage5 />} />}
      />
      {hasOtherTravellers === true && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/other-travellers/step-1`}
          element={<IntakeRoute element={<VPFOtherTravellersPage1 />} />}
        />
      )}
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/arrival/step-1`}
        element={<IntakeRoute element={<VPFArrivalPage1 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/declarations/step-1`}
        element={<IntakeRoute element={<VPFDeclarationsPage1 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/uni-enrolment/step-1`}
        element={<IntakeRoute element={<VPFUniEnrolmentPage1 />} />}
      />
      {hasTakenEnglishTest === false && (
        <Route
          path={`/:intakeId/:offerId/${VISA_PREP_FORM}/uni-enrolment/step-2`}
          element={<IntakeRoute element={<VPFUniEnrolmentPage2 />} />}
        />
      )}
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/uni-enrolment/step-3`}
        element={<IntakeRoute element={<VPFUniEnrolmentPage3 />} />}
      />
      <Route
        path={`/:intakeId/:offerId/${VISA_PREP_FORM}/feedback/step-1`}
        element={<IntakeRoute element={<VPFFeedbackPage1 />} />}
      />
      {/* Course release route - this is a URL from an email which student receives
          when released from course conflict. */}
      <Route
        path={'/:intakeId/:offerId/course-release'}
        element={<IntakeRoute redirect={`/${PERSONAL_INFO}/step-5`} />}
      />
      <Route path="/:intakeId/:offerId/visaStatusUpdate" element={<IntakeRoute element={<StatusUpdate />} />} />
      <Route path="/:intakeId/:offerId/confirmArrival" element={<IntakeRoute element={<StatusUpdate />} />} />
      <Route path="/:intakeId/:offerId/noChangeArrival" element={<IntakeRoute element={<StatusUpdate />} />} />
      <Route
        path="/:intakeId/:offerId/arrivalStatusUpdate"
        element={<IntakeRoute redirect={'/:intakeId/:offerId/dashboard?sectionId=ENROLMENT&isModalOpen=true'} />}
      />
      <Route path="/visaStatusUpdate" element={<StatusUpdate />} />
      <Route path="/confirmArrival" element={<StatusUpdate />} />
      <Route path="/noChangeArrival" element={<StatusUpdate />} />
      <Route
        path="*"
        element={
          <IntakeRoute
            redirect={
              props.offers.activeOffer?.intakeId && props.offers.activeOffer.offerId
                ? `/${props.offers.activeOffer.intakeId}/${props.offers.activeOffer.offerId}/dashboard`
                : undefined
            }
          />
        }
      />
    </SentryRoutes>
  );
};

export interface IRouterComponent extends React.ComponentClass {
  props: {
    path: string;
  };
}

export const defaultRoutes = (props: Props): string[] => {
  return CustomRoutes(props)
    .props.children.filter((component: IRouterComponent) => component?.props?.path !== undefined)
    .map((component: IRouterComponent) => component.props.path);
};
